import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { PedidoAdicionarProdutoRequest, PedidoListarRequest, Response } from './Types';

class PedidoController {
  public static async PedidoProdutoAdicionar(
    request: PedidoAdicionarProdutoRequest
  ): Promise<Response> {
    try {
      const response = await Api.post(
        `api/pedido/PedidoProdutoAdicionar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async PedidoAdicionar(
    request: any
  ): Promise<Response> {
    try {
      const response = await Api.post(
        `api/pedido/PedidoAdicionar`,
        {
          PedidoJson: JSON.stringify(request)
        }
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: response.data.ErroDetalhado };

      return retorno;

    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado: undefined
      };
      return retorno;
    }
  }

  /**
   * Finaliza várias O.S. de uma vez e consolida todas em UM pedido.
   *
   * Diferente do PedidoAdicionarOSFinalizada, que trata uma O.S. e gera um pedido para
   * ela. Aqui é tudo ou nada: se qualquer regra impedir, nenhuma O.S. é finalizada.
   *
   * O 400 é recusa de regra, não falha de sistema — a mensagem vem pronta para o
   * operador, com o número da O.S. e o motivo, e é repassada sem tradução.
   */
  public static async FinalizarLoteOS(ordensServico: number[]): Promise<Response> {
    try {
      const response = await Api.post('api/pedido/FinalizarLoteOS', { ordensServico });

      return { StatusCode: response.status, Data: response?.data };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: error?.response?.data,
        ErroDetalhado: error?.response?.data?.ErroDetalhado
                    ?? error?.response?.data?.Erro
                    ?? 'Não foi possível finalizar as ordens de serviço.',
      };
    }
  }

  public static async PedidoAdicionarOSFinalizada(osId: number): Promise<Response> {
    try {
      const response = await Api.post(
        `api/pedido/PedidoAdicionarOSFinalizada/${osId}`, {});

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async PedidoAtualizar(
    request: any,
    id: string
  ): Promise<Response> {
    try {
      const response = await Api.put(
        `api/pedido/PedidoAtualizar/${id}`,
        {
          PedidoJson: JSON.stringify(request)
        }
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async PedidoGerarNotaFiscal(
    id: number
  ): Promise<Response> {
    try {
      const response = await Api.post(`api/pedido/GerarNotaFiscal/${id}`);

      const object = response?.data;

      return {
        StatusCode: response.status,
        Data: object,
        ErroDetalhado: response.data,
      };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: error?.response?.data,
      };
    }
  }

  public static async PedidoCancelar(
    id: number
  ): Promise<Response> {
    try {
      const response = await Api.put(`api/pedido/PedidoCancelar/${id}`);

      const object = response?.data;
      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: response.data };
      return retorno;

    } catch (error: any) {

      const status = error?.response?.status;
      const apiErrorData = error?.response?.data;

      let mensagemDeErroParaUsuario = '';
      let erroDetalhado = null;

      if (apiErrorData && typeof apiErrorData === 'object') {
        erroDetalhado = apiErrorData.ErroDetalhado || apiErrorData.Erro;
        mensagemDeErroParaUsuario = apiErrorData.Erro || 'Erro desconhecido da API.';
      } else if (status) {
        erroDetalhado = error.response.data;
        mensagemDeErroParaUsuario = ErrorDictionary(status);
      } else {
        mensagemDeErroParaUsuario = 'Erro de rede. Verifique sua conexão.';
        erroDetalhado = error.message;
      }
      const retorno: Response = {
            StatusCode: status,
            Data: mensagemDeErroParaUsuario,
            ErroDetalhado: erroDetalhado,
        };
      return retorno;
    }
  }

  public static async PedidoLista(
    request: PedidoListarRequest
  ): Promise<Response> {
    try {
      const response = await Api.post(`api/pedido/Listar`, {
        VendId: request.vend_id ? request.vend_id : 0,
        VendStatus: request.vend_status,
        Finalidade: request.finalidade,
        ClientNome: request.cliente,
        VendedorNome: request.vendedor,
        Total: request.total ? request.total : 0,
        DataInicio: request.data_inicio ? request.data_inicio : null,
        DataFim: request.data_fim ? request.data_fim : null,
      });

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(
    id: string
  ): Promise<Response> {
    try {
      const response = await Api.get(`api/pedido/ListarUnico/${id}`);
      const object = response?.data;

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default PedidoController;
